import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
   providedIn: 'root'
})
export class CognitoGroupGuard  {
    constructor(private _auth: AuthService,
    private _router: Router) { }

    public canActivate(
    ): Observable<boolean> {
        return this._auth.loggedUser.pipe(map(user => {
            if (!user.inGroup) {
                this._router.navigate(['/no-access']);
            }
            return user.inGroup;
        }));
    }
}
